import { get as themeGet } from '@betterment/style-closet-react';
import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';

const curve = 'cubic-bezier(0.65, 0, 0.45, 1)';

const stroke = keyframes`
 100% {
  stroke-dashoffset: 0;
 }
`;

const StyledSvg = styled.svg`
  stroke-width: 3;
  width: 10rem;
  margin: 0 auto 2rem;
  fill: none;
  stroke: ${themeGet('colors.bmtWhite')};
`;

const StyledCircle = styled.circle`
  stroke-dasharray: 218;
  stroke-dashoffset: 218;
  animation: ${stroke} 0.6s ${curve} forwards;
  fill: none;
  stroke: ${themeGet('colors.bmtWhite')};
`;

const StyledPolyline = styled.polyline`
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: ${stroke} 0.3s ${curve} 0.8s forwards;
  fill: none;
  stroke: ${themeGet('colors.bmtWhite')};
`;

function AnimatedCheckmark() {
  return (
    <StyledSvg preserveAspectRatio="xMidYMid meet" viewBox="0 0 72 72">
      <StyledPolyline points="23.3 37.5 31.8 45.9 49.5 28.1 " />
      <StyledCircle cx="36" cy="36" r="34.5" />
    </StyledSvg>
  );
}

export default AnimatedCheckmark;
